import React, { useContext } from 'react';
import styles from './Footer.module.css';
import { ReactComponent as LightMode } from '../assets/light-mode.svg';
import { ReactComponent as DarkMode } from '../assets/night-mode.svg';
import { ThemeContext } from '../contexts/ThemeContext';

const Footer = () => {
  const { dark, setDark } = useContext(ThemeContext);

  const handleClick = () => {
    setDark(!dark);
  }

  return (
    <footer className={styles.footer}>
      <div className={dark ? styles.footerContentDark : styles.footerContentLight}>
      &copy; Praktična nastava 2020, Računarski centar, Elektrotehnički fakultet, Univerzitet u Banjoj Luci
      <div className={styles.themeToggleButtonContainer}>
        <span className={styles.themeToggleButtonTooltip}>Tema</span>
        {dark ? (
          <DarkMode className={styles.themeToggleIcon} onClick={handleClick}/>
        ) : (
          <LightMode className={styles.themeToggleIcon} onClick={handleClick}/>
        )}
      </div>
      </div>
    </footer>
  );
}

export default Footer;